import React from 'react';
import SbEditable from 'storyblok-react';
import Image from '~/components/Dynamic/Image';
import TestimonialAlt from '~/components/TestimonialAlt';
import Star from '~/components/Star';

export default function SimpleTestimonialSection({ blok }) {
  const type = blok.type || 'default';

  if (type === 'alt') {
    return <TestimonialAlt blok={{ heading: blok.testimonial, icon: blok.logo[0] }} />;
  }

  return (
    <SbEditable content={blok} key={blok._uid}>
      <section className="my-20 md:my-28 bg-beige">
        <div className="container">
          <div className="relative z-10 flex justify-center py-20 md:py-32">
            <div className="absolute inset-0 flex flex-col items-center justify-center ">
              <div className="relative w-full h-full">
                <div className="absolute bottom-[24%] left-[13%]">
                  <Star className="transform rotate-45" />
                </div>
                <div className="absolute top-[5%] md:top-[15%] right-[10%]">
                  <Star />
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center max-w-[35rem] text-center">
              <h3 className="mb-16 font-normal leading-snug u-h3 text-24px md:text-34px">
                {blok.testimonial}
              </h3>
              <div className="-mb-4">
                {blok?.logo[0] && (
                  <Image blok={blok?.logo[0]} />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  );
}
